// extracted by mini-css-extract-plugin
export default {"container":"YoutubeLink_container__RtGy5","icon":"YoutubeLink_icon__w2l+i","text":"YoutubeLink_text__gGMzS"};